module.exports = __webpack_public_path__ + "img/Game Collection.e8963f96.webp";